module.exports = __webpack_public_path__ + "img/xfsy-1-sm.08ef9245.jpg";